export enum SectionContentSize {
  SMALL,
  MEDIUM,
  LARGE,
  FULL_SCREEN,
}
